import React, {
  createContext,
  useContext,
  useRef,
  useCallback,
  useMemo,
} from 'react'
import PropTypes from 'prop-types'

const DEFAULT_MAX_ACTIVE_UPLOADS = 3

const maxActiveUploads = Number.parseInt(
  globalThis.REACT_APP_MAX_ACTIVE_UPLOADS ||
    process.env.REACT_APP_MAX_ACTIVE_UPLOADS ||
    DEFAULT_MAX_ACTIVE_UPLOADS,
  10,
)

const UploadLimitContext = createContext(null)

export const UploadLimitProvider = ({ children }) => {
  const activeCountRef = useRef(0)

  const acquireSlot = useCallback(() => {
    if (activeCountRef.current >= maxActiveUploads) {
      return false
    }
    activeCountRef.current += 1
    return true
  }, [])

  const releaseSlot = useCallback(() => {
    activeCountRef.current = Math.max(0, activeCountRef.current - 1)
  }, [])

  const contextValue = useMemo(
    () => ({ acquireSlot, releaseSlot, maxActiveUploads }),
    [acquireSlot, releaseSlot],
  )

  return (
    <UploadLimitContext.Provider value={contextValue}>
      {children}
    </UploadLimitContext.Provider>
  )
}

UploadLimitProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export const useUploadLimit = () => {
  const ctx = useContext(UploadLimitContext)
  if (!ctx) {
    throw new Error('useUploadLimit must be used within an UploadLimitProvider')
  }
  return ctx
}
